module.exports = __webpack_public_path__ + "static/img/70-3.7eb892b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/70-3.jpg
// module id = gc/w
// module chunks = 0